export const FullDateFormat: Readonly<Intl.DateTimeFormatOptions> = {
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
  second: 'numeric',
  timeZoneName: 'long',
  hour12: false,
};
